import PropTypes from 'prop-types';

/**
 * File input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.buttonText - text displayed on upload button
 * @param {string} props.acceptedFiles - file types accepted by the input
 */
const FileInput = ({ id, buttonText, acceptedFiles }) => {
    return (
        <div className="file-input">
            <label htmlFor={id}>{buttonText}</label>
            <input 
                type="file"
                id={id}
                accept={acceptedFiles}
            />
        </div>
    );
};

FileInput.propTypes = {
    id: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    acceptedFiles: PropTypes.string,
};

export default FileInput;